// import node module libraries
import { Fragment } from 'react';
import { Col, Row, Alert } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

// import sub components
import Version000001 from './Version000001';
import Version000002 from './Version000002';
import Version000003 from './Version000003';
import Version000004 from './Version000004';
import Version010200 from './Version010200';
import Version010300 from './Version010300';
import Version010400 from './Version010400';
import Version010500 from './Version010500';
import Version010501 from './Version010501';
import Version020000 from './Version020000';
import Version020001 from './Version020001';
import Version020100 from './Version020100';
import Version020101 from './Version020101';
import Version020200 from './Version020200';
import Version020201 from './Version020201';

const ChangeLog = () => {
	return (
		<Fragment>
			<Row>
				<Col xl={{ offset: 3, span: 6 }} lg={{ offset: 2, span: 8 }} md={12}>
					<Row>
						<Col lg={12} md={12} sm={12}>
							<div className="border-bottom pb-4 mb-4 d-md-flex justify-content-between align-items-center">
								<div className="mb-3 mb-md-0">
									<h1 className="mb-0 h2 fw-bold">Changelog</h1>
									<p className="mb-0">
										Wir verbessern und aktualisieren haeppy.app regelmäßig. Hier kannst du die neuesten Funktionen und Verbesserungen verfolgen.
									</p>
								</div>
							</div>
						</Col>
					</Row>
					<Version000004 />
					<hr className="my-5" />

					<Version000003 />
					<hr className="my-5" />

					<Version000002 />
					<hr className="my-5" />

					<Version000001 />
				</Col>
			</Row>
		</Fragment>
	);
};

export default ChangeLog;
